import HadrianBase from '../hadrianBase';

export enum BowlCenterTypes {
  WithinUnit = 'within unit',
  BetweenBowls = 'between bowls',
}

export class BowlCenterType extends HadrianBase {
  readonly bowlCenterType: BowlCenterTypes;
}

export default class ToolbarSettings extends HadrianBase {
  readonly showBothMeasurementsTypes: boolean;
  readonly showNotesOnPdfDrawings: boolean;
}
